import React from 'react';
import Icone from '../util/Icone';
import { faArrowRight } from '../util/icones';
import imagem4 from "../../assets/4.webp";

const Software = () => {
  return (
    <section className="grid xl:grid-cols-[3fr_5fr] xl:items-center xl:pt-24 pb-12 mb-4">
      <div className="xl:col-start-1 xl:row-start-1 xl:self-end z-10">
        <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4">Software</p>
        <h3 className="text-2xl xl:text-4xl font-semibold leading-tight mb-6">
          Sistemas sob medida para o seu processo
        </h3>
      </div>

      <div className="xl:col-start-2 xl:row-start-1 xl:row-span-2 xl:self-center flex justify-center xl:justify-end mb-10 xl:mb-0">
        <img
          src={imagem4}
          alt="Smartwatch flutuando sobre um fundo azul, exibindo a tela de um aplicativo feito sob medida."
          width="500"
          height="500"
          loading="lazy"
        className="aspect-square"
        />
      </div>

      <div className="xl:col-start-1 xl:row-start-2 xl:self-start z-10">
        <p className="text-xl leading-relaxed">
          Desenvolvemos sistemas web, mobile e desktop, com design responsivo, do jeito que a sua operação funciona.
        </p>
        <a href="/desenvolvimento-de-software" className="inline-flex items-center gap-2 font-semibold text-pattern-dark hover:underline mt-6">
          Sobre o desenvolvimento de software
          <Icone icon={faArrowRight} className="text-sm" />
        </a>
      </div>
    </section>
  );
};

export default Software;
